import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/**
 * **Octorate**
 *
 * @exports bs_36
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_36
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.querySelector('html');
        if (container && !thn.octorateObserver) {
            const octorateRefreshPage = thn.debounce(function () {
                thn.languageCheck();
                if (thn.data.pageName === 'Rooms and Rates') {
                    thn.parseCurrency();
                    thn.widgets.price.refresh();
                }
            }, 400);
            thn.octorateObserver = function octorateObserver(mutations) {
                const validMutationsLanguage = [...mutations].map((mutation) => mutation.target && mutation.target.localName === 'head' && mutation.addedNodes.length).filter(Boolean);
                if (validMutationsLanguage.length) {
                    octorateRefreshPage();
                }
            };
            thn.observeDom(container, thn.octorateObserver, {
                childList: true,
                subtree: true,
                attributes: true,
                CharacterData: true,
            });
            thn.shutdown(() => {
                octorateRefreshPage.cancel();
                thn.stopObserveDom(container, thn.octorateObserver);
                delete thn.octorateObserver;
            });
        }
    };
    /**
       * @memberOf module:bs_36
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux;
            // Perform some corrections
            function normalize(str) {
                if (str === 'jp') {
                    return 'ja';
                }
                if (str === 'gr') {
                    return 'el';
                }
                return str;
            }
            aux = document.querySelector('#SiteMain .Fright .ui-selectonemenu-label')?.textContent?.toLowerCase();
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = normalize(thn.parseUrlParameter('lang'));
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            const lang = window.location.pathname.match(/^\/\w{2}\//);
            aux = lang && lang[0] && lang[0].replace(/\//g, '');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            if (thn.data.accountUserId === 1042880 && window.location.hostname === 'www.staytogether.es') {
                resolve('en');
                return;
            }
            thn.domReady().then(function () {
                const $ = window.jQuery;
                aux = $ && $('.LangBar select:eq(0)');
                aux = aux && aux.length && (aux.val() || '').toLowerCase();
                aux = aux && normalize(aux);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('#SiteHeader\\:j_idt30_label, .Fright label').text().toLowerCase();
                aux = aux && normalize(aux);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * @memberOf module:bs_36
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new Url(ctx.baseUrl);
        if (ctx.baseUrl.match(new RegExp('https?://book.octorate.com/octobook/site/reservation/result.xhtml\\?', 'i'))) {
            if (ctx.newData.dateBegin && ctx.newData.dateEnd) {
                ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
                ctx.newData.dateEnd = ctx.newData.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
                url.query.checkin = '[date_begin]';
                url.query.checkout = '[date_end]';
                ctx.newUrl = url.decode(url.toString());
            }
        }
        else {
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_36
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#j_idt35');
        if (container && !thn.octorateObserver) {
            thn.octorateObserver = thn.debounce(function thnOctorateObserver() {
                thn.languageCheck().then(function ({ changed }) {
                    if (!changed && ctx.widget.refresh() && !ctx.widget.isSet()) {
                        ctx.widget.hide();
                    }
                });
                ctx.widget.update();
            }, 400);
            thn.observeDom(container, thn.octorateObserver, {
                childList: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(container, thn.octorateObserver);
                delete thn.octorateObserver;
            });
        }
    };
    /**
       * @memberOf module:bs_36
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        let nights;
        const dateBegin = translateDate(document.querySelector('#SiteHeader\\:checkinSelection')?.textContent, thn.data.language) || thn.parseUrlParameter('checkin')?.replace(/-/g, '/');
        const dateEnd = translateDate(document.querySelector('#SiteHeader\\:checkoutSelection')?.textContent, thn.data.language) || thn.parseUrlParameter('checkout')?.replace(/-/g, '/');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        const rooms = thn.parseNumber(document.querySelector('#SiteHeader\\:roomOutputText')?.textContent);
        const adults = document.querySelector('#SiteHeader\\:paxOutputText')?.textContent || thn.parseUrlParameter('pax') || 2;
        const children = document.querySelector('#SiteHeader\\:childrenOutputText')?.textContent || 0;
        widgetData.adults = thn.parseNumber(adults);
        widgetData.children = thn.parseNumber(children);
        widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
        widgetData.rooms = rooms;
        let price;
        function getAvailableRooms(guests) {
            return [...document.querySelectorAll('.HotelResults .room')].filter((room) => {
                const roomGuests = thn.parseNumber(room.querySelector('.guests .lspace2')?.title);
                return roomGuests >= guests;
            });
        }
        function calculatePriceForMultipleRooms() {
            const roomLowestPrices = [];
            for (let i = 0; i < rooms; i += 1) {
                const roomAdults = thn.parseNumber(document.querySelectorAll(`[id*=roomPaxTable\\:${i}\\:grid] label`)?.[0]?.textContent);
                const roomChildren = thn.parseNumber(document.querySelectorAll(`[id*=roomPaxTable\\:${i}\\:grid] label`)?.[1]?.textContent);
                const roomGuests = roomAdults + roomChildren;
                const availableRooms = getAvailableRooms(roomGuests);
                const roomPrices = availableRooms.map((availRoom) => thn.parseNumber(availRoom.querySelector('.box .price')?.textContent)).filter(Boolean);
                const minPriceRoom = Math.min(...roomPrices) / nights;
                roomLowestPrices.push(minPriceRoom);
            }
            return roomLowestPrices.reduce((total, current) => total + current, 0);
        }
        function calculatePriceForSingleRoom() {
            const availableRooms = getAvailableRooms(widgetData.guests);
            const prices = availableRooms.map((availRoom) => thn.parseNumber(availRoom.querySelector('.box .price')?.textContent)).filter(Boolean);
            return Math.min(...prices) / nights;
        }
        // multiple rooms
        if (rooms > 1) {
            price = calculatePriceForMultipleRooms().toFixed(2);
        }
        else { // one room
            price = calculatePriceForSingleRoom();
        }
        const currency = thn.parseCurrency(document.querySelector('.price')?.textContent);
        const noAvailability = !!document.querySelector('.noresults');
        if (price && currency && nights) {
            widgetData.price = price;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * Implements **bookingId**.
       *
       * @memberOf module:bs_36
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        // en, ru, nl, ja, el: 2017/09/19
        // it, fr, es, de, pt: 19/09/2017
        const dateReplacement = thn.inArray(thn.data.language, ['it', 'fr', 'es', 'de', 'pt'])
            ? '$3/$2/$1' : '$1/$2/$3';
        const dates = $('.RoomHeader .Blue:eq(0)').text().replace(/[\s\n]+/g, ' ').match(/(\d{4}\D\d{1,2}\D\d{1,2})\D+(\d{4}\D\d{1,2}\D\d{1,2})/);
        if (dates && dates.length === 3) {
            widgetData.dateBegin = dates[1].replace(/(\d+)\D+(\d+)\D+(\d+)/, dateReplacement);
            widgetData.dateEnd = dates[2].replace(/(\d+)\D+(\d+)\D+(\d+)/, dateReplacement);
        }
        const tag = 'div.ui-panelgrid-cell';
        // price, currency
        const total = Array.from(document.querySelectorAll(tag)).filter(function (el) {
            const copy = el.cloneNode(true);
            Array.from(copy.children).forEach(function (child) { child.remove(); });
            return copy.textContent.match(/total amount|totale prenotazione|montant total|importe total|gesamtbetrag|Общая стоимость брони|valor total|totaalbedrag/i);
        });
        if (total.length && total[0].nextElementSibling) {
            const price = total[0].nextElementSibling.textContent;
            widgetData.price = thn.parseNumber(price);
            widgetData.currency = thn.getCurrencyCode(price.match(/[^\d\s,.]+/)[0]);
        }
        // booking id
        const id = Array.from(document.querySelectorAll(tag)).filter(function (el) {
            const copy = el.cloneNode(true);
            Array.from(copy.children).forEach(function (child) { child.remove(); });
            return copy.textContent.match(/reservation code|codice prenotazione|code de réservation|código reserva|reservierungssnummer|Номер брони|codigo de reserva|reserveringscode/i);
        });
        if (id.length && id[0].nextElementSibling) {
            widgetData.bookingId = id[0].nextElementSibling.textContent.trim();
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_36
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = (document.querySelector('input[name="coupon"]') || {}).value;
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
